export default class Api {
  constructor(plugin) {
    this.plugin = plugin;
    this.settings = plugin.settings;
  }

  product(product_id) {
    return waOrder.cart.$products.find(`[data-product-id="${product_id}"]`);
  }

  addProduct(product_id, sku_id) {
    return this.oldSSVersion(product_id, sku_id);
  }

  oldSSVersion(product_id, sku_id) {
    const href = this.settings.cart_url;
    const data = {
      'product_id': product_id,
      'quantity': 1
    };

    return $.post(href, data, 'json')
      .then(() => {
        waOrder.cart.reload();
      });
  }

  latestSSVersion(product_id, sku_id) {
    const href = this.settings.order_url + 'add';
    const data = {
      'item[product_id]': product_id,
      'item[sku_id]': sku_id,
      'item[quantity]': 1
    };

    return $.post(href, data, 'json')
      .then(() => {
        waOrder.cart.reload();
      });
  }

  deleteProduct(product_id) {
    const $product = this.product();
    const $quantity = $product.find('input.js-product-quantity');

    $quantity.val(0);

    this.getOption('cart').saveCart().then((api) => {
      $product.remove();
      this.render();
    });
  }
}
